import { createBrowserStorage } from '@thehotelsnetwork/browser-storage';

export default createBrowserStorage();
